import { useState, useMemo, useCallback } from 'react'
import DEALS from '../data/deals'
import { DEALS_PER_PAGE, LOAD_MORE_COUNT } from '../data/constants'
import { sortDeals } from '../utils/sort'

/**
 * Central hook that owns all deal filtering, sorting and pagination state.
 */
export const useDeals = () => {
  const [search,   setSearch]   = useState('')
  const [category, setCategory] = useState('All')
  const [sort,     setSort]     = useState('trending')
  const [visible,  setVisible]  = useState(DEALS_PER_PAGE)

  // Reset pagination when filters change
  const handleSearch = useCallback((val) => {
    setSearch(val)
    setVisible(DEALS_PER_PAGE)
  }, [])

  const handleCategory = useCallback((cat) => {
    setCategory(cat)
    setVisible(DEALS_PER_PAGE)
  }, [])

  const handleSort = useCallback((s) => {
    setSort(s)
    setVisible(DEALS_PER_PAGE)
  }, [])

  const loadMore = useCallback(() => {
    setVisible((v) => v + LOAD_MORE_COUNT)
  }, [])

  const filtered = useMemo(() => {
    let result = DEALS

    if (category !== 'All') {
      result = result.filter((d) => d.category === category)
    }

    if (search.trim()) {
      const q = search.toLowerCase().trim()
      result = result.filter(
        (d) =>
          d.title.toLowerCase().includes(q)    ||
          d.platform.toLowerCase().includes(q) ||
          d.category.toLowerCase().includes(q)
      )
    }

    return sortDeals(result, sort)
  }, [search, category, sort])

  const paginatedDeals = filtered.slice(0, visible)
  const hasMore        = visible < filtered.length
  const remaining      = filtered.length - visible

  return {
    // state
    search, category, sort,
    // derived
    deals: paginatedDeals,
    totalFiltered: filtered.length,
    hasMore,
    remaining,
    // handlers
    setSearch: handleSearch,
    setCategory: handleCategory,
    setSort: handleSort,
    loadMore,
  }
}
